var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "main_center",
    },
    [
      _c(
        "div",
        { staticClass: "right-content clearfix busWinessRight" },
        [
          true
            ? _c("formInformation", { ref: "formInformation" })
            : _c("viewInformation", { ref: "viewInformation" }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }